import { Container, Typography } from '@mui/material';

export default function Page404() {
  return (
    <Container sx={{ display: 'flex', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
      <Typography variant="h3">404 | Not Found</Typography>
    </Container>
  );
}
